import { render, staticRenderFns } from "./PlantPower.vue?vue&type=template&id=af738b88&scoped=true"
import script from "./PlantPower.vue?vue&type=script&lang=js"
export * from "./PlantPower.vue?vue&type=script&lang=js"
import style0 from "./PlantPower.vue?vue&type=style&index=0&id=af738b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af738b88",
  null
  
)

export default component.exports